import React from 'react';
import { Input, } from '../../../../../Shared/index';

const NameTheUnit = ({ nameError, unitName, updateUnitName, timesSubmitted, }) => {
  function onCancel() { updateUnitName('') }

  function onChange(e) { updateUnitName(e.target.value) }

  return (
    <section aria-labelledby="nameTheAssignmentHeader" className="assignment-section">
      <div className="assignment-section-header">
        <span className="assignment-section-number">1</span>
        <span className="assignment-section-name" id="nameTheAssignmentHeader">Name the assignment</span>
      </div>
      <div className="assignment-section-body">
        <Input
          className="large bordered"
          error={nameError}
          handleCancel={onCancel}
          handleChange={onChange}
          id="activity-pack-name"
          label="Activity pack name"
          timesSubmitted={timesSubmitted}
          type="text"
          value={unitName}
        />
      </div>
    </section>
  )
}

export default NameTheUnit
